const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ components
const { MortgageRequestDocumentationCenterItem } = require('./mortgageRequestDocumentationCenterItem');

class MortgageRequestDocumentationMortgagesLoans extends React.Component {
    constructor(props) {
        super(props);
        this.holders = props.holders;

        this.buildHoldersList = this.buildHoldersList.bind(this);
    }

    builLoansContent(holdersList) {
        let cardContent = null;

        if ((holdersList.length > 0) && (typeof holdersList[0] !== undefined)) {
            cardContent = (
                <ContentBox
                    title={formatText('mortgageRequestDocumentationCenter-subtitleSectionMortgageLoans')}
                    smallTitle={true}
                    titleSeparator={true}
                    customClassName="mortgage-request-documentation-center__section"
                >
                    {holdersList}
                </ContentBox>
            );
        }

        return cardContent;
    }

    buildHoldersList(dataHolder, index) {
        const holderDocuments = dataHolder.documents;
        const firstHolderLabel = formatText('mortgageRequestDocumentationCenter-subtitleFirstHolder');
        const secondHolderLabel = formatText('mortgageRequestDocumentationCenter-subtitleSecondHolder');

        let listItem;

        if (holderDocuments.length > 0 && (index === 0 || index === 1)) {
            const labelHolder = index === 0 ? firstHolderLabel : secondHolderLabel;
            const holdersListItem = dataHolder.documents.map(
                this.buildHoldersListItem(
                    dataHolder.idHolder,
                    dataHolder.idDocumentType,
                    dataHolder.idDocumentNumber
                )
            );

            listItem = (
                <div className="mortgage-request-documentation-center__section__holder" key={index}>
                    <OKBoxTitle
                        value={labelHolder}
                        size="medium"
                        isNotSeparator={true}
                    >
                    </OKBoxTitle>
                    <ol className="list-unstyled mortgage-request-documentation-center__list">
                        {holdersListItem}
                    </ol>
                </div>
            );
        }

        return listItem;
    }

    buildHoldersListItem(idHolder, idDocumentType, idDocumentNumber) {
        return (dataHolderItem, index) => (
            <MortgageRequestDocumentationCenterItem
                key={index}
                documentType={dataHolderItem.documentType}
                documentTypeLabel={dataHolderItem.documentTypeLabel}
                documentStatus={dataHolderItem.documentStatus}
                idHolder={idHolder}
                loanId={dataHolderItem.documentLoanId}
                idDocumentType={idDocumentType}
                idDocumentNumber={idDocumentNumber}
            />
        );
    }

    render() {
        const holdersList = this.holders.map(this.buildHoldersList);
        const cardContent = this.builLoansContent(holdersList);

        return cardContent;
    }
}

MortgageRequestDocumentationMortgagesLoans.propTypes = {
    holders: PropTypes.array
}

module.exports = MortgageRequestDocumentationMortgagesLoans;
